$(document).ready(() => {

    var url = new URL(location.href);
    if (url.pathname == '/pages/verify-email') {
        var params = new URLSearchParams(url.search);
        var show_mail_flag = params.get('resend');
        if ( show_mail_flag != null ) {
            $(".resend-response-msg").slideDown(300);
        }
    }

    const DOMAIN = "https://cms.monotypefonts.com";

    const API_URL = `${DOMAIN}` + (Shopify.locale === 'en' ? '' : Shopify.locale === 'pt-BR' ? '/pt' : '/' + Shopify.locale) + '/getcontent/block?type=image_block&id=' + "191";

    async function getRandomImageData(api_url) {
        let response = await fetch(api_url);
        let data = await response.json();
        const {random_images} = data.data;
        let random_index = Math.floor(Math.random() * random_images.length);
        let random_image = random_images[random_index];
        if (random_image.image) {
            if (window.innerWidth < 991) {
                $(".img-back").css("background-image",`url(${DOMAIN}${random_image.image.image_path}), linear-gradient(0deg, rgba(186, 175, 215, 0.2), rgba(186, 175, 215, 0.2))`);
            }
            else {
                $(".img-back").css({backgroundImage: `linear-gradient(transparent, rgb(30, 36, 44) 80%), url(${DOMAIN}${random_image.image.image_path})`});
            }
        }
        if (random_image.artby) {
            $(".art-by > a").text(`${random_image.artby.ctaText}`).attr("href", `${random_image.artby.ctaLink}`);
        } else {
            $(".art-by,.dots").hide();
        }
        if (random_image.typeface) {
            $(".typeface > a").text(`${random_image.typeface.ctaText}`).attr("href", `${random_image.typeface.ctaLink}`);
        } else {
            $(".typeface").hide();
        }
    }

    getRandomImageData(API_URL);
    $("#add-company").on('submit',( function (e) {
        if ($(this).valid()) {
            e.preventDefault();
            $(".modal").css("display","block");
        var trialDays = "30";
        var formData = {
            "email":$('#email').val(),
            "firstName":$('#fname').val(),
            "lastName":$('#lname').val(),
            "country":$('#country').val(),
            "companyName":$('#company').val(),
            "isAutoTrialCustomer": false,
            "inventories": "enterprise,mtf 100k addendum",
            "terminationDate": (new Date(new Date().setDate(new Date().getDate() - 1))).toISOString(),
            "CompanySize":$('#CompanySize').val()
        }
        var authToken ="Bearer " + atob($('#token').val());
        $.ajax({
            type: "POST",
            url: "https://enterprise.monotype.com/en/admin/customer",
            headers: {
                'Authorization': authToken,
                'Content-Type':'application/json'
            },
            data: JSON.stringify(formData),
            success: function (msg) {
                //window.location.href = redirect_url_add_company.replace('&orgId=[orgId]','');
                setTimeout(function() {
                    var finalURL = Shopify.locale === "pt-BR" ? `${window.location.origin}/pt/pages/company-list` : `${window.location.origin}/pages/company-list`;
                    var locale = Shopify.locale.replace('&amp;', '&');

                    var loginUrl = "https://secure.monotype.com/authorize?response_type=code&client_id=vR9LphUR57bacuEXwUC9SaZOolB5Fug9&state=STATE&redirect_uri=https://auth-api.monotype.com/api/handlelogin?params=mtfprod___mtfprod___[finalURL]&audience=https://monotypeidp.us.auth0.com/api/v2/&scope=openid%20profile%20email%20offline_access&ui_locales=[locale]";
                    loginUrl = loginUrl
                    .replace("[finalURL]", finalURL)
                    .replace("[locale]", locale);

                    window.location.href = loginUrl;
                }, 4000);
            },
            error: function (err) {
                console.log(JSON.stringify(err));
                if (err.status == '400') {
                    $(".response-msg-text").hide();
                    switch (err.responseJSON.ErrorCode) {
                        case 'DUPLICATE_COMPANY_NAME' :
                            $(".err-duplicate-company").show();
                            $(".modal").css("display","none");
                            break;
                        case 'EMAIL_ALREADY_EXIST' :
                            $(".err-duplicate-email").show();
                            $(".modal").css("display","none");
                            break;
                        case 'INVALID_INPUT' :
                            $(".err-invalid-input").show();
                            $(".modal").css("display","none");
                            break;
                        default:
                            $(".err-default").show();
                            $(".modal").css("display","none");
                            break;
                    }
                }
                else {
                    $(".response-msg-text").hide();
                    $(".err-default").show();
                    $(".modal").css("display","none");
                }
                $(".response-msg").slideDown(300);
                $(".modal").css("display","none");
                document.getElementById("response-error").scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        });
        }
    }));
});
